export default {
  REACT_APP_API_BASE:
    "https://petful-server-nhgi-taylorp.herokuapp.com/api" ||
    process.env.REACT_APP_API_BASE
};
